/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Toast_Update_PxkInputs */

const vi_scl_toast_update_pxk = /** @type {(inputs: Scl_Toast_Update_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu thay đổi phiếu xuất lô lấy hương`)
};

/**

* @param {Scl_Toast_Update_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_toast_update_pxk = /** @type {((inputs?: Scl_Toast_Update_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Toast_Update_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_toast_update_pxk(inputs)
});